import { styled } from '@mui/material';

export const BreadcrumbContainer = styled('nav')`
  margin-top: 20px;
  margin-bottom: 30px;
`;

export const BreadcrumbList = styled('ol')`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;

  @media print {
    display: none;
  }
`;
